import { LanguageCheckIcon, SElementContainer } from '../../../containers/Sidebar/Sidebar.styles';
import { Layout } from '../../Layout/Layout';
import FlagUnitedKingdom from '../../../assets/icons/flags/uk-round.svg';
import FlagHolland from '../../../assets/icons/flags/netherlands-round.svg';
import FlagSweden from '../../../assets/icons/flags/sweden-round.svg';
import FlagSpain from '../../../assets/icons/flags/spain-round.svg';
import FlagBrazil from '../../../assets/icons/flags/brazil-round.svg';
import FlagFinland from '../../../assets/icons/flags/finland-round.svg';
import Check from '../../../assets/icons/checkmark--yellow.svg';
import SidebarElement from '../../../containers/Sidebar/SidebarElement';
import i18n, { ELanguages, originalLanguageNames } from '../../../i18n';
import { useNavigate } from 'react-router-dom';
import { Page } from '../../Page/Page';
import { setLanguage } from '../Settings/settingsSlice/actionCreators';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { selectUserId } from '../../../containers/Login/LoginSlice';

function Language() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const userId = useAppSelector(selectUserId);

  const saveLanguage = (language: ELanguages) => {
    if (!userId) {
      return;
    }

    dispatch(
      setLanguage(userId, language, () => {
        i18n.changeLanguage(language);
        navigate('/sidebar');
      })
    );
  };

  const getRightIcon = (lang: ELanguages) => {
    return i18n.language === lang ? <LanguageCheckIcon src={Check} alt="checkmark" /> : undefined;
  };

  const flagByLanguage = {
    [ELanguages.se]: FlagSweden,
    [ELanguages.en]: FlagUnitedKingdom,
    [ELanguages.nl]: FlagHolland,
    [ELanguages.fi]: FlagFinland,
    [ELanguages.pt]: FlagBrazil,
    [ELanguages.es]: FlagSpain,
    [ELanguages['en-TT']]: FlagUnitedKingdom,
  };

  const languages: ELanguages[] = [
    ELanguages.se,
    ELanguages.en,
    ELanguages.nl,
    ELanguages.fi,
    ELanguages.pt,
    ELanguages.es,
  ];

  return (
    <Layout isMessageLayout message="language" to="/sidebar" showBottomTabs>
      <Page>
        <SElementContainer role="languagesContainer">
          {languages.map((item, key) => (
            <SidebarElement
              key={key}
              name={originalLanguageNames[item]}
              e2eId={item}
              icon={flagByLanguage[item]}
              rightIcon={getRightIcon(item)}
              onClick={() => {
                saveLanguage(item);
              }}
            />
          ))}
        </SElementContainer>
      </Page>
    </Layout>
  );
}

export default Language;
